import vkConfig from '#config/vk.json';

import { useCountryCode, useLocale } from '#src/app/shared/hooks/l10n';

export function useVkAvailable(): boolean {
	const countryCode = useCountryCode();
	const locale = useLocale();
	return vkConfig.locales.includes(locale) || vkConfig.countries.includes(countryCode);
}
